$(function() {
  // Automatically trigger loading state for primary buttons that have loading text defined.
  // This behavior can be avoided by adding the 'no-loading' class to the button.
  $('body').on('click', '.btn-primary[data-loading-text]:not(.no-loading)', function () {
    $(this).buttonState('loading');
  });

  $('[data-bs-toggle="tooltip"]').tooltip();
});
